import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerDeliveryAddress } from '@/models';
import { CountryCode } from '@/store/ui';
import { countries } from '@/constants';

@Component({
  name: 'CmgFindADeliveryAddress',
})
export default class CmgFindADeliveryAddress extends Vue {
  get savedDeliveryAddresses() {
    return this.$appStore.state.customer.deliveryAddresses || [];
  }

  get cmgLocationIconUrl(): string {
    return this.$appStore.state.cms.images.icons.chipotleLocation.default;
  }

  get deliveryCopy(): string {
      return 'Menu pricing for delivery is higher and fees apply.'
  }

  mounted() {
    if (this.$services.customer.isLoggedIn()) {
      this.$services.customer.refreshCustomerDeliveryAddresses();
    }
  }

  selectAddress(address: CustomerDeliveryAddress) {
    this.$services.ui.setCountryProfile(address.countryCode === CountryCode.CA ? countries.ca : countries.us, false);

    // catch lat/long strings then open selected address view
    const formattedAddress = address;
    formattedAddress.latitude = parseFloat(formattedAddress.latitude as any);
    formattedAddress.longitude = parseFloat(formattedAddress.longitude as any);

    this.$emit('select-saved-address', formattedAddress);
  }

  editSavedAddress(address: CustomerDeliveryAddress, event: any) {
    this.$services.ui.setCountryProfile(address.countryCode === CountryCode.CA ? countries.ca : countries.us, false);
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility(
      'deliveryAddress',
      true,
      {
        isSavedAddress: true,
        deliveryAddress: address
      }
    );
    this.$services.ui.firstFocus();
  }
}
